import { ProfilesResponse } from '@/features/user';
import { isTruthyOrZero } from '@/utils';

export const getCreditText = (
  selectedCourse?: ProfilesResponse.EnrolledCourse
) => {
  if (
    selectedCourse?.credit_policy === 'ce' &&
    isTruthyOrZero(selectedCourse?.current_credit?.bought_credit)
  ) {
    return `${selectedCourse?.current_credit?.bought_credit ?? 0} Credits`;
  }
  return '';
};
